import VIPGames from './VIPGames';
export default VIPGames;
